import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import Block from 'components/structure/Block/Block';

export const TextBlock = styled(Block)`
  min-height: ${props => (props.autoHeight ? 'auto' : '520px')};
  align-self: center;
  justify-content: center;

  ${breakpointsMedia({
    lg: css`
      justify-content: center;
    `,
  })}
`;

TextBlock.displayName = 'TextBlock';
